export const flags = {
  TRAVELLING_TO_FILTER: {
    key: 'qantas-holidays-travelling-to-filter',
    variations: {
      HIDE_TRAVELLING_TO_FILTER: 'hide-travelling-to-filter',
      SHOW_TRAVELLING_TO_FILTER: 'show-travelling-to-filter',
    },
  },
};

export const FEATURE_FLAGS_FOR_ANALYTICS = [flags.TRAVELLING_TO_FILTER.key];
